import { gql } from '@apollo/client';
import { buildIdentityTerm } from './predecessor-identity';
import { composedMap } from '../shape-map';
import { buildCursorTerm } from './paging/cursor-term';

export const OPERATION_NAME = 'AuditLogPredecessors';
export const PREDECESSOR_ALIAS_LIMIT = 25;

const ROW_SELECTION = 'id timestamp action description userId userName userEmail debugData';

export function buildDocument(rows) {
  assertWithinAliasLimit(rows);
  const variableDecls = rows.map((_, i) => `$w${i}: org_audit_logs_bool_exp!`).join(', ');
  const fields = rows.length ? rows.map(buildAliasField).join('\n    ') : '__typename';

  return gql(`
    query ${OPERATION_NAME}${rows.length ? `(${variableDecls})` : ''} {
      ${fields}
    }
  `);
}

export function buildVariables(rows) {
  assertWithinAliasLimit(rows);
  return rows.reduce((variables, row, i) => {
    variables[`w${i}`] = buildAliasWhere(row);
    return variables;
  }, {});
}

function buildAliasField(_, index) {
  return `p${index}: org_audit_logs(where: $w${index}, order_by: [{timestamp: desc}, {id: desc}], limit: 1) { ${ROW_SELECTION} }`;
}

function buildAliasWhere(row) {
  return {
    _and: [
      buildIdentityTerm({ composedMap, identity: row.identity }),
      buildCursorTerm({ timestamp: row.timestampRaw, id: row.id }, 'desc'),
    ],
  };
}

function assertWithinAliasLimit(rows) {
  if (rows.length > PREDECESSOR_ALIAS_LIMIT) {
    throw new Error(
      `AuditLogPredecessors: ${rows.length} predecessor lookups requested for one page, but the ` +
        `p0…p24 alias scheme supports at most ${PREDECESSOR_ALIAS_LIMIT}. PAGE_SIZE must not grow ` +
        'past 25 without extending this scheme — never truncate the request silently.'
    );
  }
}
